import { PrinterSeries } from '@oolio-group/domain';

const printerTimeout = (series: PrinterSeries) =>
  series == PrinterSeries.TM_U220 ? 300000 : 60000;

export default printerTimeout;
